module.exports = __webpack_public_path__ + "media/you_have_applied_now_what/you-have-applied-now-what_635x150-9ba679fb.png";